export default __webpack_public_path__ + "static/media/EyeFillerSerum.d09e7948.jpeg";